import {
  DefaultProjectorFn,
  MemoizedSelector,
  createSelector,
} from '@ngrx/store';
import { identity } from 'rxjs';

import { selectQueryParam, selectRouteParam } from './router.selectors';

export interface EntityRouterSelectors<T> {
  selectRouteParam: MemoizedSelector<
    Record<string, any>,
    T | undefined,
    DefaultProjectorFn<T | undefined>
  >;
  selectQueryParam: MemoizedSelector<
    Record<string, any>,
    T | undefined,
    DefaultProjectorFn<T | undefined>
  >;
  selectRoutedId: MemoizedSelector<
    Record<string, any>,
    T | undefined,
    DefaultProjectorFn<T | undefined>
  >;
  selectQueriedId: MemoizedSelector<
    Record<string, any>,
    T | undefined,
    DefaultProjectorFn<T | undefined>
  >;
}

interface RouterEntitySelectorConfig<T> {
  routeParam: string;
  queryParam?: string;
  parser?: (x: any) => T;
}

export function createRouterEntitySelectors<T>({
  routeParam,
  queryParam,
  parser = identity,
}: RouterEntitySelectorConfig<T>) {
  const selectEntityRouteParam = selectRouteParam(routeParam);
  const selectEntityQueryParam = selectQueryParam(queryParam || routeParam);
  return {
    selectRouteParam: selectEntityRouteParam,
    selectQueryParam: selectEntityQueryParam,
    selectRoutedId: createSelector(selectEntityRouteParam, (param) =>
      parser(param)
    ),
    selectQueriedId: createSelector(selectEntityQueryParam, (param) =>
      parser(param)
    ),
  };
}
